import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { appUrl } from '../properties/properties';

const ServiceUnavailable = ({ onRetry }) => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        const response = await fetch(`${appUrl}/lastvulnerabilities`, {
          signal: controller.signal,
        });
        clearTimeout(timeout);
        if (response.ok) {
          clearInterval(interval);
          onRetry();
        }
      } catch {
        // Backend still down, continue polling
      }
    }, 30000);

    const tick = setInterval(() => {
      setCountdown((prev) => (prev <= 1 ? 30 : prev - 1));
    }, 1000);

    return () => {
      clearInterval(interval);
      clearInterval(tick);
    };
  }, [onRetry]);

  const handleRetry = () => {
    setCountdown(30);
    onRetry();
  };

  return (
    <div>
      <Header />
      <main>
        <section className="banner"></section>
        <div className="container-1200 container-up">
          <div className="service-unavailable">
            <div className="service-unavailable-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="80"
                height="80"
                fill="none"
                stroke="#004087"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M32 6L4 58h56L32 6z" />
                <line x1="32" y1="24" x2="32" y2="40" />
                <circle cx="32" cy="48" r="2" fill="#004087" stroke="none" />
              </svg>
            </div>
            <h1>Service Temporarily Unavailable</h1>
            <p className="service-unavailable-message">
              The European Vulnerability Database is currently undergoing
              maintenance or experiencing temporary issues. We apologise for the
              inconvenience.
            </p>
            <p className="service-unavailable-sub">
              This page will automatically check for service recovery every 30
              seconds.
            </p>
            <p className="service-unavailable-countdown">
              Next check in <strong>{countdown}</strong> seconds
            </p>
            <button
              className="btn-secondary service-unavailable-retry"
              onClick={handleRetry}
            >
              Try Again
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ServiceUnavailable;
